/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';
import FakeDiscussion from './FakeDiscussion';
export default class UserAchievement extends Model {
  assignedAt() {
    return Model.attribute('assignedAt').call(this);
  }
  user() {
    return Model.hasOne('user').call(this);
  }
  achievement() {
    return Model.hasOne('achievement').call(this);
  }
  achievementLevel() {
    return Model.hasOne('achievementLevel').call(this);
  }

  // Core groups notifications by their subject discussion, so unlock notifications need a stand-in.
  discussion() {
    return new FakeDiscussion();
  }
}
flarum.reg.add('glowingblue-gamilytics', 'common/models/UserAchievement', UserAchievement);